<template>
  <div class="contentHome">
    <div class="centerPage">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
        <el-breadcrumb-item>
          <a href="javascript:void(0);" class="aHref" @click="returnBack">心理测试</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>测试详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="detail">
        <div class="leftCon ">
          <h2>{{ detail.title }}</h2>
          <span class="description">{{ detail.subTitle }}</span>
          <img :src="detail.exhibitImg" alt="" class="detailImg">
          <p class="content">{{ detail.briefDesc }}</p>
          <div class="notice flex">
            <span class="tit">测试须知</span>
            <div class="question">
              <p><span>题目数：</span><span>{{ detail.subjectCount }}题</span></p>
              <p><span>预计时长：</span><span>{{ detail.exceptTime }}</span></p>
              <p>
                <span>价格：</span>
                <span v-if="hasNo">已支付</span>
                <span v-else>
                    <el-radio-group v-model="resultType" @change="changeExamType">
                        <el-radio
                            :label=1>系统测评{{
                            detail.price == 0 ? '免费' : (detail.price + '元')
                          }}</el-radio>
                        <el-radio
                            :label=2>专业测评{{
                            detail.majorPrice == 0 ? '免费' : (detail.majorPrice + '元')
                          }}</el-radio>
                    </el-radio-group>
                </span>
              </p>
            </div>
            <div style="width: 32%; text-align: center;">
              <div v-if="!hasNo">
                <div v-if="!isFree">
                  <div>
                    <el-radio v-model="payWay" label="wx">微信</el-radio>
                    <el-radio v-model="payWay" disabled label="zfb">支付宝</el-radio>
                  </div>
                  <div style="margin-top: 20px;">
                    <el-button style="height: 28px; line-height: 28px; width: 80px; padding: 0;" type="primary" plain
                               @click="showQRImg">去支付
                    </el-button>
                  </div>
                </div>
                <div v-else>
                  <el-button style="height: 28px; line-height: 28px; width: 80px; padding: 0;" type="primary" plain @click="freeAnswer">免费测试
                  </el-button>
                </div>
              </div>
              <div v-if="hasNo">
                <el-button style="height: 28px; line-height: 28px; width: 80px; padding: 0;" type="primary" plain
                           @click="startAnswer">去答题
                </el-button>
              </div>
            </div>
          </div>
          <div class="comment" v-for="(obj,ind) in msgList" :key="ind">
            <el-avatar v-if="obj.isAnonymous==0 && obj.userAvatar" :src="obj.userAvatar" shape="circle"
                       :size="50"></el-avatar>
            <el-avatar v-else icon="el-icon-user-solid" shape="circle" :size="50"></el-avatar>
            <div>
              <h2>{{ obj.userName }}</h2>
              <p>{{ obj.msgDate }}</p>
              <p>{{ obj.msgContent }}</p>
            </div>
          </div>
        </div>
        <div class="rightCon">
          <div class="tab">
            <h3 class="tit">热门测试</h3>
            <div class="popularTest">
              <el-tooltip class="item" v-for="(item,ind) in popularTest" :key="ind"
                          effect="dark" :content="item.title" placement="bottom-start">
                <span class="overFlow" @click="toDetail(item.id)">{{ item.title }}</span>
              </el-tooltip>
            </div>
          </div>
          <div class="tab">
            <h3 class="tit">新型测试</h3>
            <div class="popularTest">
              <el-tooltip class="item" v-for="(item,ind) in newTest" :key="ind"
                          effect="dark" :content="item.title" placement="bottom-start">
                <span class="overFlow" @click="toDetail(item.id)">{{ item.title }}</span>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="qrImgDialog"
               width="300px"
               title="订单支付"
               class="tips paySuccess"
               top="0"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               @close="clearAllTimer"
               :show-close="true">
      <div style="text-align: center">
        <div style="position: relative">
          <img :src="qrImgUrl"/>
          <div v-show="qrExpire.expire" class="expireMask">
            <div class="text">二维码已失效</div>
          </div>
        </div>
        <div>{{ qrExpire.minute|numberFmt(2) }}:{{ qrExpire.second|numberFmt(2) }}</div>
      </div>
    </el-dialog>

    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        class="tips paySuccess"
        top="0"
        :visible.sync="dialogVisible"
        width="400px">
      <img src="../../assets/img/success.png" alt="" width="140">
      <p>支付成功！</p>
      <div class="sub">
        <el-button @click="waitAnswer">稍后再答</el-button>
        <el-button @click="startAnswer">开始答题</el-button>
      </div>
    </el-dialog>

    <!-- 登录弹窗 -->
    <loginDialog ref="loginDialog"></loginDialog>
  </div>
</template>

<script>
import base from '@/api/common';
import loginDialog from "../loginDialog";

export default {
  name: "exam_detail",
  data() {
    return {
      popularTest: [],
      newTest: [],
      detail: {},
      dialogVisible: false,
      id: this.$route.query.id,
      back: this.$route.query.back,
      hasNo: false,
      isFree: false,

      msgList: [],
      payWay: 'wx',
      payWayText: '微信支付',
      qrImgDialog: false,
      qrImgUrl: '',
      qrExpire: {
        expire: false,
        minute: 5,
        second: 0,

        default_second: 0, //默认设置失效时间
        default_minute: 5
      },

      global_timer: {
        timeoutTimer: [],
        intervalTimer: []
      },

      resultType: 1,//测试结果类型
      expense: 0,//花费

      isLogin: false,
    }
  },
  components: {loginDialog},
  inject: ['reload'],
  async mounted() {
    if (this.id === null) {
      this.$router.back();
    }
    this.getData(this.id);

    // 侧边top
    this.$ajax.get(base.api.exam.top).then((res) => {
      if (res.data.status === 'success') {
        // 限制最多6个
        this.popularTest = res.data.hotList.slice(0, 6);
        this.newTest = res.data.newList.slice(0, 6);
      }
    });
    // 此题是否存在订单
    let curUser = await base.utils.getCurrent();
    if (curUser) {
      this.isLogin = true;
      this.$ajax.get(base.api.exam.hasNo.replace("{id}", this.id)).then((res) => {
        if (res.data.status === 'success') {
          this.hasNo = (res.data.hasNo === 1);
        }
      })
    }
  },
  methods: {
    getData(id) {
      this.$ajax.get(base.api.exam.details.replace("{id}", id)).then((res) => {
        if (res.data.status === 'success') {
          this.detail = res.data.data;
          if (this.detail.price == 0) {
            this.isFree = true;
          }
        } else {
          this.$router.back();
        }
      });
      // load msg
      this.$ajax.get(base.api.exam.message.list.replace("{id}", id), {params: {page: 1, size: 5}}).then((res) => {
        if (res.data.status === 'success') {
          this.msgList = res.data.rows;
        }
      });
    },
    toDetail(id) {
      location.href = "examDetail?back=" + this.back + "&id=" + id
    },
    startAnswer() {
      this.$router.push({name: 'examQuestion', query: {back: this.back, id: this.id}})
    },
    waitAnswer() {
      this.dialogVisible = false;
      this.hasNo = true;
    },
    returnBack() {
      if (this.back == 1) {
        this.$router.push({name: 'exam'})
      } else if (this.back == 2) {
        this.$router.push({name: 'serviceType'})
      }
    },
    async showQRImg() {
      let user = await base.utils.getCurrent();
      if (!user) { // 未登录
        this.$refs.loginDialog.dialogVisible = true;
        this.$refs.loginDialog.reloadCode('vcode-user');
        return;
      }

      if (user.type === 2) {
        this.$message.error("医生不允许答题")
      } else {
        if (this.resultType === 1) {
          this.expense = this.detail.price;
        } else {
          this.expense = this.detail.majorPrice;
        }
        let data = {
          type: this.payWay,
          id: this.id,
          resultType: this.resultType,
        };
        this.qrImgDialog = true;
        this.$ajax.post(base.basePath + "exams/pay/authorize/toPay/" + this.payWay + "?" + $.param(data)).then((res) => {
          if (res.data.status === 'success') {
            // 时间重置
            this.qrExpire.second = this.qrExpire.default_second;
            this.qrExpire.minute = this.qrExpire.default_minute;

            this.qrImgUrl = res.data.url;
            let orderToken = res.data.token;
            let timer;
            let orderTimer;
            orderTimer = setInterval(() => {
              this.$ajax.post(base.basePath + "exams/pay/authorize/isPay/" + orderToken).then((res) => {
                if (res.data.status === 'success') {
                  if (res.data.data == 1) { //已支付
                    this.qrImgDialog = false;
                    this.dialogVisible = true;
                    this.clearAllTimer();
                  }
                } else {
                  this.clearAllTimer();
                  this.$message.error(res.data.message);
                }
              });
            }, 3000);
            this.global_timer.intervalTimer.push(orderTimer);
            // 失效时间
            timer = setInterval(() => {
              let changeSecond = this.qrExpire.second - 1;
              if (changeSecond >= 0) {
                this.qrExpire.second = changeSecond;
              } else {
                let changeMin = this.qrExpire.minute - 1;
                if (changeMin >= 0) {
                  this.qrExpire.second = 59;
                  this.qrExpire.minute = changeMin;
                } else {
                  this.qrExpire.second = 0;
                  this.qrExpire.minute = 0;
                  this.qrExpire.expire = true;
                  // 分钟耗尽 结束
                  this.clearAllTimer();
                }
              }
            }, 1000);
            this.global_timer.intervalTimer.push(timer);
          } else {
            this.qrImgDialog = false;
            this.$message.error(res.data.message);
          }
        });
      }
    },
    clearAllTimer() {
      if (this.global_timer.timeoutTimer) {
        this.global_timer.timeoutTimer.forEach((v, i, arr) => {
          clearTimeout(v);
        });
        this.global_timer.timeoutTimer.length = 0;
      }

      if (this.global_timer.intervalTimer) {
        this.global_timer.intervalTimer.forEach((v, i, arr) => {
          clearInterval(v);
        });
        this.global_timer.intervalTimer.length = 0;
      }
    },
    changeExamType(type) {
      if (type == 1) { // 系统评测
        if (this.detail.price == 0) {
          this.isFree = true;
        } else {
          this.isFree = false;
        }
      } else {
        this.isFree = false;
      }
    },
    freeAnswer() {
      if (!this.detail || !this.detail.id) {
        return
      }
      this.$ajax.post(base.basePath + 'exams/pay/authorize/free/' + this.detail.id).then(res => {
        if (res.data.status === 'success') {
          this.$router.push({name: 'examQuestion', query: {back: this.back, id: this.id}})
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(err => {
        console.error(err);
        this.$message.error('操作错误');
      })

    },
  },
  filters: {
    numberFmt(num, length) {
      return (Array(length).join('0') + num).slice(-length);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/psychological.scss";

.aHref {
  font-size: 13px;
  color: #999999;
  font-weight: 400;
}

.expireMask {
  position: absolute;
  width: 100%;
  height: 100%;
  text-align: center;
  top: 0;
  background: #ccc;
  opacity: 0.8;
  color: #FFF;

  .text {
    margin: 32% auto;
    font-size: 20px;
    font-weight: bold;
    width: 130px;
    background: #000;
  }
}
</style>
